import React, { useCallback, useState, useEffect } from "react";
import { Input, Select, Button } from "antd";
import { FormControl } from "@mui/material";
import { CloseOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
import {
	TextField,
	Box,
	Typography,
	Chip,
	Stack,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from '../../app/assets/svgComponent/cancel.svg';
import SaveI from '../../app/assets/svgComponent/save.svg';

const TableForm = ({
	item,
	onChange,
	onSave,
	onClear,
	isEdit,
	handleAddEducation,
	onArrayInputChange,
	handleRemoveEducation,
	onClose = () => {},
}) => {
	const [inputValues, setInputValues] = useState({
		skill: "",
		company: "",
	});
	const [isFormValid, setIsFormValid] = useState(false);

	const handleChange = useCallback(
		(event) => {
			const { name, value } = event.target;
			onChange({ target: { name, value } });
		},
		[onChange]
	);

	const handleArrayChange = useCallback(
		(type, itemToAdd, itemToRemove) => {
			if (itemToAdd) {
				const updatedArray = [...(item[type] || []), itemToAdd];
				onChange({ target: { name: type, value: updatedArray } });
				if (type === "skills") {
					setInputValues((prev) => ({ ...prev, skill: "" }));
				} else if (type === "notable_company") {
					setInputValues((prev) => ({ ...prev, company: "" }));
				}
			} else if (itemToRemove) {
				const updatedArray = item[type].filter((i) => i !== itemToRemove);
				onChange({ target: { name: type, value: updatedArray } });
			}
		},
		[item, onChange]
	);

	const handleSkillAdd = () => {
		if (inputValues.skill) {
			handleArrayChange("skills", inputValues.skill);
		}
	};

	const handleCompanyAdd = () => {
		if (inputValues.company) {
			handleArrayChange("notable_company", inputValues.company);
		}
	};

	const handleEducationChange = useCallback(
		(index, field, value) => {
			onArrayInputChange(index, field, value, "education_qualification");
		},
		[onArrayInputChange]
	);

	const handleAlphabeticInput = (e) => {
		e.target.value = e.target.value.replace(/[^a-zA-Z0-9@.\s]/g, '');
	};

	const handleNumericInput = (e) => {
		const value = e.target.value.replace(/[^0-9.]/g, '');
		e.target.value = value;
	};

	// Add this handler function
	const handlePhoneInput = (e) => {
		// Remove any non-numeric characters
		let value = e.target.value.replace(/\D/g, '');
		
		// Limit to 10 digits
		value = value.slice(0, 10);
		
		// Update the field value
		e.target.value = value;
		handleChange(e);
	};

	useEffect(() => {
		const isValid =
			item.candidate_name &&
			item.candidate_email &&
			item.candidate_phone &&
			item.current_location &&
			item.current_ctc &&
			item.expected_ctc &&
			item.notice_period &&
			item.current_company &&
			item.experience;
		setIsFormValid(isValid);
	}, [item]);

	const inputStyle = {
		width: "368px",
		height: "34px",
		padding: "6px 10px",
		gap: "8px",
		borderRadius: "6px",
		border: "1px solid rgba(255, 255, 255, 1)",
		boxShadow: "0px 1px 2px 0px rgba(17, 24, 39, 0.08), 0px 0px 0px 1px rgba(17, 24, 39, 0.1)",
		backgroundColor: "#F3F4F6",
		fontSize: "14px",
		fontFamily: "Inter"
	};

	const labelStyle = {
		display: "block",
		fontSize: "14px",
		color: "#374151",
		marginBottom: "8px",
		fontWeight: "500"
	};

	const handleSave = () => {
		onSave();
		onClose();
	};

	return (
		<div style={{ 
			width: "410px",
			height: "89vh",
			fontFamily: "inter",
			padding: "0",
			borderRadius: "12px",
			backgroundColor: "#FFFFFF",
			position: "fixed",
			right: "12px",
			top: "12px",
			overflowY: "auto",
			overflowX: "hidden",
			boxShadow: `
				0px 20px 44px 0px rgba(0, 0, 0, 0.1),
				0px 80px 80px 0px rgba(0, 0, 0, 0.09),
				0px 180px 108px 0px rgba(0, 0, 0, 0.05),
				0px 319px 128px 0px rgba(0, 0, 0, 0.01),
				0px 499px 140px 0px rgba(0, 0, 0, 0)
			`,
			paddingRight: "12px",
			boxSizing: "border-box",
			display: "flex",
			flexDirection: "column"
		}}>
			{/* Header */}
			<div style={{
				width: "100%",
				height: "48px",
				padding: "8px 16px",
				borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				background: "rgba(247, 247, 248, 1)"
			}}>
				<div style={{ 
					display: "flex", 
					alignItems: "center", 
					gap: "6px"
				}}>
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M7.00156 4.19961H2.10156V3.14961C2.10156 2.57001 2.57196 2.09961 3.15156 2.09961H5.22706C5.46086 2.09961 5.67996 2.21651 5.80946 2.41111L7.00156 4.19961Z" fill="#2563EB" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M2.10156 4.19971H10.8516C11.4312 4.19971 11.9016 4.67011 11.9016 5.24971V9.79971C11.9016 10.9589 10.9608 11.8997 9.80156 11.8997H4.20156C3.04236 11.8997 2.10156 10.9589 2.10156 9.79971V4.19971Z" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					<span style={{ 
						fontWeight: "500",
						fontSize: "16px"
					}}>
						{isEdit ? 'Edit Applicant' : 'Add New Applicant'}
					</span>
				</div>
			</div>

			{/* Form Content */}
			<div style={{ 
				padding: "24px 12px 24px 24px", 
				width: "100%",
				flex: 1,
				overflowY: "auto"
			}}>
				{/* Basic Details */}
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Candidate Name <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="candidate_name"
							value={item?.candidate_name || ""}
							onChange={handleChange}
							onInput={handleAlphabeticInput}
							style={{...inputStyle}}
							placeholder="Enter candidate name"
						/>
					</FormControl>
				</div>

				{/* Updated Fields */}
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Email <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="candidate_email"
							type="email"
							value={item?.candidate_email || ""}
							onChange={handleChange}
							onInput={handleAlphabeticInput}
							style={{...inputStyle}}
							placeholder="Enter candidate email"
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Phone <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="candidate_phone"
							value={item?.candidate_phone || ""}
							onChange={handlePhoneInput}
							inputProps={{
								maxLength: 10,
								pattern: '[0-9]*',
								inputMode: 'numeric'
							}}
							style={{...inputStyle}}
							placeholder="Enter 10 digit phone number"
							error={item?.candidate_phone && item.candidate_phone.length !== 10}
							helperText={item?.candidate_phone && item.candidate_phone.length !== 10 ? "Phone number must be 10 digits" : ""}
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Current Location <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="current_location"
							value={item?.current_location || ""}
							onChange={handleChange}
							onInput={handleAlphabeticInput}
							style={{...inputStyle}}
							placeholder="Enter current location"
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Current CTC <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="current_ctc"
							value={item?.current_ctc || ""}
							onChange={handleChange}
							onInput={handleNumericInput}
							style={{...inputStyle}}
							placeholder="Enter current CTC"
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Expected CTC <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="expected_ctc"
							value={item?.expected_ctc || ""}
							onChange={handleChange}
							onInput={handleNumericInput}
							style={{...inputStyle}}
							placeholder="Enter expected CTC"
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Notice Period <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="notice_period"
							value={item?.notice_period || ""}
							onChange={handleChange}
							onInput={handleNumericInput}
							style={{...inputStyle}}
							placeholder="Enter notice period"
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Current Company <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="current_company"
							value={item?.current_company || ""}
							onChange={handleChange}
							onInput={handleAlphabeticInput}
							style={{...inputStyle}}
							placeholder="Enter current company"
						/>
					</FormControl>
				</div>
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Experience <span style={{ color: 'red' }}>*</span></label>
					<FormControl fullWidth>
						<Input
							name="experience"
							value={item?.experience || ""}
							onChange={handleChange}
							onInput={handleNumericInput}
							style={{...inputStyle}}
							placeholder="Enter experience"
						/>
					</FormControl>
				</div>

				{/* Skills Section */}
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Skills</label>
					<div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "8px" }}>
						{item.skills?.map((skill, index) => (
							<div key={index} style={{
								background: "#EFF6FF",
								padding: "4px 8px",
								borderRadius: "4px",
								display: "flex",
								alignItems: "center",
								gap: "4px"
							}}>
								<span style={{ color: "#2563EB" }}>{skill}</span>
								<CloseOutlined 
									onClick={() => handleArrayChange("skills", null, skill)}
									style={{ color: "#2563EB", fontSize: "12px", cursor: "pointer" }}
								/>
							</div>
						))}
					</div>
					<div style={{ display: "flex", gap: "8px" }}>
						<Input
							placeholder="Add skill"
							value={inputValues.skill}
							onChange={(e) => setInputValues(prev => ({ ...prev, skill: e.target.value }))}
							style={{...inputStyle, flex: 1}}
						/>
						<PlusOutlined 
							onClick={handleSkillAdd}
							style={{ 
								cursor: "pointer",
								padding: "8px",
								color: "#2563EB",
								marginRight: "15px"
							}}
						/>
					</div>
				</div>

				{/* Notable Companies */}
				<Box>
					<Typography variant="subtitle1">Notable Companies</Typography>
					<FormControl fullWidth>
						<Stack direction="row" spacing={1} sx={{ flexWrap: "wrap", gap: 1 }}>
							{item.notable_company?.map((company, index) => (
								<Chip
									key={index}
									label={company}
									onDelete={() =>
										handleArrayChange("notable_company", null, company)
									}
									color="secondary"
								/>
							))}
						</Stack>
						<Stack direction="row" spacing={1} alignItems="center" mt={2}>
							<Input
								placeholder="Add notable company"
								value={inputValues.company}
								onChange={(e) =>
									setInputValues((prev) => ({ ...prev, company: e.target.value }))
								}
								style={{...inputStyle , marginBottom: "16px"}}
							/>
							<PlusOutlined 
							onClick={handleCompanyAdd}
							style={{ 
								cursor: "pointer",
								padding: "8px",
								color: "#2563EB",
								marginRight: "15px",
								marginBottom: "16px"
							}}
						/>
						</Stack>
					</FormControl>
				</Box>

				{/* Education Qualifications */}
				<div style={{ marginBottom: "24px" }}>
					<label style={labelStyle}>Education Qualifications</label>
					{item?.education_qualification?.map((education, index) => (
						<div
							key={index}
							style={{ display: "flex", gap: "8px", marginBottom: "16px" }}
						>
							<Input
								name={`degree_name-${index}`}
								value={education.degree_name || ""}
								onChange={(e) =>
									handleEducationChange(index, "degree_name", e.target.value)
								}
								style={{...inputStyle, flex: 1}}
								placeholder="Enter degree name"
							/>
							<Input
								name={`start_date-${index}`}
								type="date"
								value={education.start_date || ""}
								onChange={(e) =>
									handleEducationChange(index, "start_date", e.target.value)
								}
								style={{...inputStyle, flex: 1}}
							/>
							<Input
								name={`end_date-${index}`}
								type="date"
								value={education.end_date || ""}
								onChange={(e) =>
									handleEducationChange(index, "end_date", e.target.value)
								}
								style={{...inputStyle, flex: 1}}
							/>
							<DeleteOutlined 
								onClick={() => handleRemoveEducation(index)}
								style={{ 
									cursor: "pointer",
									padding: "8px",
									color: "#2563EB",
									visibility: item.education_qualification.length === 1 ? 'hidden' : 'visible'
								}}
							/>
						</div>
					))}
					<Button
						onClick={handleAddEducation}
						disabled={!isFormValid}
						style={{
							border: "1px solid #D1D5DB",
							borderRadius: "6px",
							background: "white",
							cursor: isFormValid ? "pointer" : "not-allowed",
							display: "flex",
							alignItems: "center",
							gap: "8px",
							padding: "4px 12px"
						}}
					>
						<PlusOutlined style={{ color: "#2563EB" }} />
						<span>Add Education</span>
					</Button>
				</div>
			</div>

			{/* Footer Buttons */}
			<div style={{ 
				width: "400px", 
				height: "45px", 
				display: "flex",
				gap: "10px",
				padding: "16px",
				background: "rgba(247, 247, 248, 1)",
				borderTopLeftRadius: "12px",
				borderTopRightRadius: "12px",
				position: "sticky",
				bottom: 0,
				left: 0,
				right: 0,
				borderTop: "1px solid rgba(0, 0, 0, 0.1)"
			}}>
				
				
					<img
					onClick={onClear}
					 src={CancelIcon} alt="Cancel" style={{ cursor:'pointer', width:' 179px', height: '50px' }} />
					
				
				
					<img
					onClick={isFormValid ? handleSave : undefined}
					 src={SaveI} alt="Save" style={{ 
						cursor: isFormValid ? 'pointer' : 'not-allowed', 
						width: '179px', 
						height: '36px', 
						marginTop:'5px', 
						opacity: isFormValid ? 1 : 0.5
					}} />
			</div>
		</div>
	);
};

export default React.memo(TableForm);
